import { render, staticRenderFns } from "./TurnoverPercentagePerUserCurrentYearInformation.vue?vue&type=template&id=2b778102&"
import script from "./TurnoverPercentagePerUserCurrentYearInformation.vue?vue&type=script&lang=ts&"
export * from "./TurnoverPercentagePerUserCurrentYearInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports